import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {LESSON} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('lessons.title'),
                url: this.props.course_id !== undefined
                    ? `${LESSON}?course_id=${this.props.course_id}`
                    : LESSON,
                showHeader: true,
                showCount: true,
                tableShadow:false,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'text',
                        key: 'title',
                        isVisible: true,
                    },
                    {
                        title: this.$t('course'),
                        type: 'custom-html',
                        key: 'course',
                        isVisible: true,
                        modifier: (course) => {
                            return course ? course.title ? course.title : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('lessons.order'),
                        type: 'text',
                        key: 'order',
                        isVisible: true,
                    },
                    {
                        title: this.$t('attachments'),
                        type: 'component',
                        componentName: 'app-attachments-column',
                        key: 'attachments',
                        modifier: (h, params) => {
                            const files = params.row.attachments ? params.row.attachments.filter(file => isImage(file.full_url)) : [];
                            return h('app-attachments-column', {
                                props: {
                                    attachments: files, // Only image files will be passed
                                },
                            });
                        },
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-lesson-modal',
                        modalId: 'lesson-modal',
                        url: LESSON,
                        name: 'edit',
                        modifier: row => this.$can('update_lesson')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'lesson-modal',
                        url: LESSON,
                        name: 'delete',
                        modifier: row => this.$can('delete_lesson')
                    },
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        name: 'view_details',
                        url: LESSON,
                    },
                ],
            }
        }
    }
}
export function isImage(url) {
    return /\.(jpeg|jpg|gif|png|svg|webp)$/i.test(url);
}
